<script>
  import {getContext, onMount} from 'svelte';
  import QRCode from 'qrcode';
  import {PATHS} from '@/const/paths';
  import {lang$} from '@/store/lang';
  import {getDownloadChannels} from '@/modules/header/popups/download/constants';
  import lang from '../../Header.lang';

  const LG = getContext('LG');

  export let width = 398;

  let ratio = width / 398;
  let qrcodeUrl = '';

  $: channels = getDownloadChannels($lang$)

  onMount(() => updateQrCodeUrl());

  async function updateQrCodeUrl() {
    const href = window.location.origin + PATHS.DOWNLOAD.pathname;
    qrcodeUrl = await QRCode.toDataURL(href, {
      width: 140 * ratio,
      margin: 0,
    });
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    padding: calc(var(--ratio-) * 24px);
    width: calc(var(--ratio-) * 398px);
    background: rgba(26, 29, 31, 0.96);
    backdrop-filter: blur(10px);
    cursor: default;
    overflow: hidden;
  }
  .wrap .qrcode {
    margin-top: 0;
    margin-bottom: 0;
    box-sizing: border-box;
    border-radius: 12px;
    padding: 12px;
    width: calc(var(--ratio-) * 140px);
    background: #fff;
  }
  .title {
    line-height: calc(var(--ratio-) * 20px);
    font-size: calc(var(--ratio-) * 14px);
    white-space: normal;
  }
  .download-con {
    margin-left: calc(var(--ratio-) * 24px);
    width: calc(var(--ratio-) * 186px);
    height: auto;
  }
  .download {
    display: block;
  }
  .qrcode-box {
    width: 140px;
    background: transparent;
  }
  .channel {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #6C6E74;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .gap-8 {
    gap: 8px;
  }
  .fw4 {
    font-weight: 700;
  }
  .channel-desc {
    transform: translateX(-1px);
  }
</style>

<div class="wrap TW" style="--ratio-:{ratio}">
  <div class="df aic ais">
    <div class="tc qrcode-box">
      <img class="qrcode lazyload" alt="qr code" data-src={qrcodeUrl} />
      <div class="title mt8 f14">{LG(lang.ScanTo)}</div>
    </div>

    <div class="download-con df fdc gap-8">
      {#each channels as channel}
        {#if channel.isSplit}
          <span class="fw1 f10 tc">{LG(lang.Or)}</span>
        {/if}
        <a target="_blank" rel="noopener noreferrer nofollow" class="df channel" href={channel.href}>
          <img class="download lazyload" alt="app store" data-src={channel.icon} width={24} />
          <div class="df fdc jcc TW ml12">
            {#if channel.desc}
              <span class="f10 fw1 channel-desc">{LG(channel.desc)}</span>
            {/if}
            <span class="fw4 f14">{LG(channel.channelName)}</span>
          </div>
        </a>
      {/each}
    </div>
  </div>
</div>
